import React from "react";
import PageLayout from "./PageLayout";
import PageHero from "./PageHero";
import SplitStorySection from "./SplitStorySection";

/** Split hero layout for engagement detail pages (Nashta, Plant Kindness, etc.) */
const EngagementSplitPage = ({ title, image, imageAlt, showDonate, children }) => (
  <PageLayout>
    <PageHero title={title} light />
    <SplitStorySection image={image} imageAlt={imageAlt} showDonate={showDonate}>
      {children}
    </SplitStorySection>
  </PageLayout>
);

export default EngagementSplitPage;
